import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './PizzaListing.css';
import logo from '../../assets/waseeny-logo.png';
import api from '../../config/api';
import { SearchSkeleton } from '../Common/PageSkeleton';
import { getImageUrl } from '../../utils/imageUrl';

const PizzaListing = () => {
  const navigate = useNavigate();
  const [restaurants, setRestaurants] = useState([]);
  const [dishes, setDishes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPizzaData = async () => {
      try {
        setLoading(true);
        const res = await api.get('/search', { params: { q: 'pizza' } });
        if (res.data) {
          setRestaurants(res.data.restaurants || []);
          setDishes(res.data.products || res.data.dishes || []);
        }
      } catch (err) {
        console.error('Failed to fetch pizza listings:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchPizzaData();
  }, []);

  return (
    <div className="pizza-listing-container">
      <header className="pizza-header">
        <div className="header-left" onClick={() => navigate('/home')} style={{ cursor: 'pointer' }}>
          <img src={logo} alt="Waseeny" className="logo-image" />
        </div>

        <nav className="header-nav-pizza" aria-label="Pizza navigation">
          <button type="button" className="nav-item-pizza" onClick={() => navigate('/search')}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <circle cx="8" cy="8" r="6" stroke="#333" strokeWidth="1.5"/>
              <path d="M12.5 12.5L16 16" stroke="#333" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
            Search
          </button>
          <button type="button" className="nav-item-pizza" onClick={() => navigate('/profile')}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <circle cx="9" cy="6" r="3" stroke="#333" strokeWidth="1.5"/>
              <path d="M3 16C3 13 5.5 11 9 11C12.5 11 15 13 15 16" stroke="#333" strokeWidth="1.5"/>
            </svg>
            Account
          </button>
          <button type="button" className="nav-item-pizza" onClick={() => navigate('/checkout')}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M3 3L6 3L8 13L14 13" stroke="#333" strokeWidth="1.5"/>
              <circle cx="9" cy="15.5" r="1" fill="#333"/>
              <circle cx="13" cy="15.5" r="1" fill="#333"/>
            </svg>
            Cart
          </button>
        </nav>
      </header>

      <main className="pizza-main">
        <div className="pizza-title-section">
          <h1 className="pizza-title">Pizzas & Italian</h1>
          <p className="pizza-subtitle">Cheesilicious pizzas and mouthwatering Italian specialties.</p>
        </div>

        {loading ? (
          <SearchSkeleton />
        ) : restaurants.length === 0 && dishes.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '60px 20px', color: '#666' }}>
            <div style={{ fontSize: '48px', marginBottom: '12px' }}>🍕</div>
            <h3>No pizza restaurants nearby</h3>
            <p>Explore other delicious food categories on the home page.</p>
            <button 
              onClick={() => navigate('/home')} 
              style={{ marginTop: '16px', padding: '10px 24px', background: '#C5192D', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}
            >
              Browse Home
            </button>
          </div>
        ) : (
          <>
            <div className="pizza-count">
              <h2>{restaurants.length} Restaurants serving Pizzas</h2>
            </div>

            <div className="pizza-restaurants-grid">
              {restaurants.map((restaurant) => (
                <div 
                  key={restaurant._id || restaurant.id} 
                  className="pizza-restaurant-card" 
                  onClick={() => navigate(`/restaurant/${restaurant._id || restaurant.id}`)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="pizza-restaurant-image" style={{
                    backgroundImage: restaurant.profileImage ? `url(${getImageUrl(restaurant.profileImage)})` : undefined,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundColor: '#f3f4f6'
                  }}>
                    {restaurant.rating && (
                      <div className="pizza-restaurant-tag">★ {restaurant.rating.toFixed ? restaurant.rating.toFixed(1) : restaurant.rating}</div>
                    )}
                  </div>
                  <div className="pizza-restaurant-info">
                    <h3 className="pizza-restaurant-name">{restaurant.name?.en || restaurant.name || 'Restaurant'}</h3>
                    <div className="pizza-restaurant-meta">
                      <span className="pizza-rating">
                        ★ {restaurant.rating || '4.5'}
                      </span>
                      <span className="pizza-separator">•</span>
                      <span className="pizza-time">{restaurant.deliveryTime || '25-35 min'}</span>
                    </div>
                    <p className="pizza-restaurant-category">
                      {Array.isArray(restaurant.cuisines) ? restaurant.cuisines.join(', ') : (restaurant.cuisines || 'Pizza, Fast Food')}
                    </p>
                    <p className="pizza-restaurant-location">{restaurant.address?.city || restaurant.city || 'Local Area'}</p>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </main>
    </div>
  );
};

export default PizzaListing;
